import axios from 'axios';
import Box from '@mui/material/Box';
import Loader from 'react-loader-spinner';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState, useCallback } from 'react';

import { classes } from '../styles';
import MuiTable from '../../../components/Dashboard/Common/Table';
import DashboardNavBar from '../../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../../components/Dashboard/Common/SidebarMenu';

const columns = [
  { id: 'no', label: 'No', minWidth: 50, align: 'left' },
  { id: 'firstName', label: 'First Name', minWidth: 150, align: 'left' },
  { id: 'lastName', label: 'Last Name', minWidth: 150, align: 'left' },
  {
    id: 'username',
    label: 'Username',
    minWidth: 150,
    align: 'left',
  },
  {
    id: 'role',
    label: 'Role',
    minWidth: 100,
    align: 'left',
  },
  { id: 'active', label: 'Active', minWidth: 100, align: 'left' },
  {
    id: 'email',
    label: 'Email',
    minWidth: 250,
    align: 'left',
  },
  {
    id: 'registered',
    label: 'Registered',
    minWidth: 100,
    align: 'left',
  },
  {
    id: 'image',
    label: 'Image',
    minWidth: 400,
    align: 'left',
  },
  {
    id: 'bio',
    label: 'Bio',
    minWidth: 400,
    align: 'left',
  },
];

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem('lhcfToken');

const DashboardUsersPage = () => {
  const [users, setUsers] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const handleRowClick = (rowData) => {
    console.log('TABLE ROW CLICKED: ', rowData);
  };

  const createData = (
    no,
    firstName,
    lastName,
    username,
    role,
    active,
    email,
    registered,
    image,
    bio
  ) => ({
    no,
    firstName,
    lastName,
    username,
    role,
    active,
    email,
    registered,
    image,
    bio,
  });

  const prepareTableRows = useCallback((users) => {
    const rows = [];

    users.forEach((user, index) => {
      rows.push(
        createData(
          index + 1,
          user.firstName,
          user.lastName,
          user.username,
          user.role,
          user.active ? 'Yes' : 'No',
          user.email,
          user.createdAt.split('T')[0],
          user.image,
          user.bio
        )
      );
    });

    return rows;
  }, []);

  const fetchUsers = useCallback(() => {
    axios
      .get(`${baseUrl}/auth/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(({ data: { data } }) => {
        const users = prepareTableRows(data);

        setUsers(users);
        setLoading(false);
      })
      .catch((err) => {
        setLoadingError(true);
        setLoading(false);
      });
  }, [prepareTableRows]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.pageContainer}>
        {loading ? (
          <Box sx={classes.commonMargin}>
            <Loader type="Oval" color="#B40404" height={80} width={80} />
          </Box>
        ) : loadingError ? (
          <Box sx={classes.commonMargin}>
            <Typography variant="subtitle1" component="div">
              Could not fetch users. Refresh or check back later.
            </Typography>
          </Box>
        ) : (
          <MuiTable
            columns={columns}
            rows={users}
            handleRowClick={handleRowClick}
          />
        )}
      </Box>
    </Box>
  );
};

export default DashboardUsersPage;
